import React from "react";
import "./components.css";

export const TopSection = ()=>(
  <div className="sectionTop  perfectCenter">
    <div className="empty" />
    <p>
      Fastest, cheapest and the most reliable way
      <br />
      to check your product market fit
    </p>
    <div className="empty" />
  </div>
);
